import { Add, Remove } from '@mui/icons-material';
import { Grid, Typography, Button } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MemberProfileData } from '../models/member';

type MemberDetailProfileGroupDisplayProps = {
  label: string;
  childProfileItems: MemberProfileData[];
  fullWidth: boolean;
  maxItemsShown: number;
};

export const MemberDetailProfileGroupDisplay = (props: MemberDetailProfileGroupDisplayProps) => {
  const { label, childProfileItems, fullWidth, maxItemsShown } = props;
  const { t } = useTranslation(['common']);
  const limitItems = childProfileItems.length > maxItemsShown;
  const [showMoreProfileData, setShowMoreProfileData] = useState<boolean>(false);

  const isLimited = !showMoreProfileData && limitItems;
  const childItems = isLimited ? childProfileItems.slice(0, maxItemsShown) : childProfileItems;

  return childItems.length > 0 ? (
    <Grid item xs={fullWidth ? 'auto' : 6} zeroMinWidth sx={{ maxWidth: fullWidth ? '100%' : '50%' }}>
      <Typography variant='body1' component='div' sx={{ fontWeight: 500 }}>
        {label.replace(/<BR>/gi, '')}
      </Typography>
      <Typography variant='body1' component='div'>
        {childItems.map((x) => (
          <div key={x.itemName}>
            {x.textValue !== null && x.textValue !== '' && (
              <>
                <Typography variant='caption' color='text.secondary'>
                  {x.itemName}
                </Typography>
                <Typography variant='body2'>{x.textValue}</Typography>
              </>
            )}
            {x.textValue === null && x.itemName}
          </div>
        ))}
        {limitItems && (
          <Button
            variant='text'
            size='small'
            startIcon={showMoreProfileData ? <Remove fontSize='small' /> : <Add fontSize='small' />}
            sx={{ textTransform: 'none' }}
            onClick={() => setShowMoreProfileData(!showMoreProfileData)}
          >
            {showMoreProfileData ? t('common:button.showLess') : `${t('common:button.showMore')} (${childProfileItems.length - maxItemsShown})`}
          </Button>
        )}
      </Typography>
    </Grid>
  ) : null;
};
